import React from "react";
import Col from "../Flex/Col";
import Row from "../Flex/Row";
import { useClasses } from "../../";
import Button from "../Forms/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-light-svg-icons";
const styles = (theme) => ({
    sidebar: {
        width: "250px",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            position: "fixed",
            left: 0,
            top: 0,
            zIndex: 101,
        },
    },
    header: {
        position: "relative",
        zIndex: 100,
        backgroundColor: "#fff",
        height: "50px",
    },
    mainCol: {
        overflow: "hidden",
    },
    head: {
        height: "50px",
        color: "#fff",
    },
    logo: {
        fontSize: "1.5rem",
    },
    topbar: {
        overflowX: "hidden",
    },
});
export default function Admin(props) {
    const classes = useClasses(styles);
    const { showSideBar, setShowSidebar } = props;
    return (React.createElement(Row, { flow: "row nowrap" },
        React.createElement(Col, { override: { col: classes.sidebar }, sm: !showSideBar ? "hidden-down" : undefined, md: "250px", print: "hidden" }, React.Children.map(props.sidebar, (child, index) => {
            if (React.isValidElement(child))
                return (React.createElement(React.Fragment, { key: "admin-content-element-" + index }, React.cloneElement(child, {
                    ...child.props,
                    onClose: () => {
                        if (setShowSidebar)
                            setShowSidebar(false);
                    },
                })));
            return (React.createElement(React.Fragment, { key: "admin-content-element-" + index }, child));
        })),
        React.createElement(Col, { stretch: true, md: "calc(100% - 250px)", override: { col: classes.mainCol } },
            React.createElement(Row, null,
                React.createElement(Col, { print: "hidden" },
                    React.createElement("header", { className: classes.header },
                        React.createElement(Row, { stretch: true, verticalAlign: "center", spacing: 8 },
                            React.createElement(Button, { xs: "40px", md: "hidden-up", onClick: () => {
                                    if (setShowSidebar)
                                        setShowSidebar(true);
                                } },
                                React.createElement(FontAwesomeIcon, { icon: faBars })),
                            React.createElement(Col, { xs: "rest", override: { col: classes.topbar } }, props.topbar)))),
                React.createElement(Col, null, props.children)))));
}
